module.exports = __webpack_public_path__ + "img/img-03.b16bb725.png";